import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LinkExpired = () => {
    return (_jsxs("div", { style: { textAlign: 'center', marginTop: '80px' }, children: [_jsx("h2", { style: { marginBottom: '20px' }, children: "wachtwoord reset token is verlopen" }), _jsxs("p", { style: { marginTop: '20px' }, children: ["Ga terug naar ", _jsx("a", { href: '/login', children: "de inlogpagina" }), "."] })] }));
};
export default LinkExpired;
